export * from "./src/http-loader";



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ngx-translate/http-loader/index.js
// module id = 556
// module chunks = 216